import ShopifyCartModule from '../class/ShopifyCartModule';
import cartMixin from '../vue-mixins/cart-mixin';
import cartCheckoutMixin from '../vue-mixins/cart-checkout-mixin';
export default class extends ShopifyCartModule {
    constructor(m) {
        super(m);
    }

    async init() {
        // Await cart state
        await super.init()

        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [ cartMixin, cartCheckoutMixin],

            beforeCreate() {
                this.moduleInstance = moduleInstance
            },

            mounted() {},

            methods: {}
        });
    }


    // Hooks
    onAddItem(cart) {
        //console.log('[add] - addedItem from product form', cart)

        // Open Modal
        this.onOpenModal()

        /* /!\ Refresh Cart Vue.js */
        this.app?.onAddNewItem?.(cart)

        // Set cart counter
        this.setCartCounter(cart)
    }

    onRemoveItem(cart) {
        //console.log('[remove] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onUpdateItem(cart) {
        //console.log('[update] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onRefreshCart(cart) {
        //console.log('[refresh] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onCannotAddMoreItem(itemId) {
        this.call('cannotAddMoreItem', itemId, 'ProductForm')
    }

    setCartCounter(cart) {
        const cartLength = cart.item_count
        this.call('setCartCounter', cartLength, 'CartCounter')
    }

    setCartData(cartState) {
        this.call('setVueCartData', cartState, 'CartModal')
    }

    setVueCartData(cartState) {
        this.app?.setCartData?.(cartState, true)
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
